import React from 'react';
import { useTranslation } from "react-i18next";

export function FormRequiredText() {
  const { t } = useTranslation();
  return <span className="cf-required" aria-hidden="true">({t("form-required")})</span>;
}
